var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubmissionWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 59,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M2.004 49.005V5.755c0-1.651 1.355-2.994 3.02-2.994h31.884c1.666 0 3.02 1.343 3.02 2.995v43.249c0 1.652-1.354 2.995-3.02 2.995H5.024c-1.665 0-3.02-1.343-3.02-2.995z",
    fill: "#291475"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.514V4.264C0 2.614 1.354 1.27 3.02 1.27h31.884c1.666 0 3.02 1.343 3.02 2.995v43.249c0 1.652-1.354 2.995-3.02 2.995H3.02c-1.666 0-3.02-1.343-3.02-2.995z",
    fill: "#ED1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.294 47.861V3.921L2.626 3.919 2.624 47.86l32.67.001z",
    fill: "#FEFFFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.78 8.712H4.356v3.833H21.78V8.712z",
    fill: "#B0B0B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M31.363 14.462H4.356v3.833h27.007v-3.833z",
    fill: "#B0B0B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.78 26.136H4.356v3.834H21.78v-3.834z",
    fill: "#B0B0B0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M31.363 31.886H4.356v3.833h27.007v-3.833z",
    fill: "#B0B0B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.933 0H11.998c-.846 0-1.523.678-1.523 1.511v2.27c0 .84.684 1.511 1.523 1.511h13.935a1.52 1.52 0 001.523-1.511V1.51A1.52 1.52 0 0025.933 0z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M26.501.107c.048.141.068.29.068.45v2.27c0 .84-.684 1.511-1.53 1.511H11.104c-.203 0-.4-.033-.575-.107.19.624.772 1.074 1.462 1.074h13.935a1.52 1.52 0 001.523-1.51V1.517a1.508 1.508 0 00-.948-1.41z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.05 2.149H13.874a.601.601 0 01-.603-.598c0-.329.27-.598.603-.598h10.183c.332 0 .603.269.603.598a.603.603 0 01-.61.598z",
    fill: "#B0B0B0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M37.924 3.459l-.007 44.867a2.187 2.187 0 01-2.2 2.183H2.2C.989 50.509 0 49.529 0 48.326V46.58l31.647.007c1.219 0 2.2-.98 2.2-2.19l.008-43.127h1.868c1.212 0 2.2.98 2.2 2.189z",
    fill: "#291475"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.19,
    x: 23.896,
    y: 30.608,
    width: 26.136,
    height: 26.136,
    rx: 6,
    transform: "rotate(-.09 23.896 30.608)",
    fill: "#1B365D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.09,
    y: 28.808,
    width: 26.136,
    height: 26.136,
    rx: 6,
    transform: "rotate(-.09 22.09 28.808)",
    fill: "#ED1B2E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#submission_wide_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M34.095 49.428l-6-5.982a.922.922 0 01-.003-1.303l1.302-1.306a.922.922 0 011.303-.002l4.043 4.03 8.631-8.658a.922.922 0 011.304-.002l1.305 1.301c.36.36.362.943.002 1.304L35.398 49.426a.922.922 0 01-1.303.002z",
    fill: "#291475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.879 46.962l-5.797-5.78a.89.89 0 01-.002-1.259l1.257-1.26a.89.89 0 011.26-.003l3.905 3.893 8.338-8.364a.89.89 0 011.26-.002l1.261 1.257a.89.89 0 01.002 1.26L35.138 46.96a.89.89 0 01-1.26.002z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "submission_wide_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-.089 20858.172 -17095.513)",
    d: "M0 0h19.882v19.521H0z"
  })))));
}

export default SvgSubmissionWide;